// extracted by mini-css-extract-plugin
export default {"container":"Breadcrumb_container__UpPA3","nav":"Breadcrumb_nav__x14kN","navItem":"Breadcrumb_navItem__WiW53","dark":"Breadcrumb_dark__za9Jn"};